<template>
    <v-app class="ma-0 pa-0" id="app">
      <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="fullPage"></loading>
      <h1 v-if="error">Tut uns Leid, aber der angegebene Aktivierungslink ist uns nicht bekannt.</h1>
    </v-app>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { activateUser } from "../api";
export default {
  name: "Activate",
  props: ["hash"],
        components: {
            Loading
        },
  data() {
    return {
      error: false,
      isLoading: false,
      fullPage: true
    };
  },
  created() {
    this.isLoading = true;
    this.activate().then(res=>{
        this.isLoading = false
    })
  },
  methods: {
    activate() {
      return activateUser(this.hash)
        .then(() => {
          window.setTimeout(() => {
            this.$router.push({ name: "signin" });
          }, 1000);
        })
        .catch(err => {
          this.error = true;
          window.setTimeout(() => {

          }, 1000);
        });
    }
  }
};

</script>